import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import { useQuery } from "@tanstack/react-query";
// import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
// import { fetch_all, fetch_one } from "../../../lib/v31lib";
// import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../lib/practice';

import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
// import { LineChart, Line, XAxis, YAxis, CartesianGrid } from 'recharts';

// @ts-ignore
import HeroImg from "../../../img/newest_additions/warme_welkom_maand1.png";
// @ts-ignore
import {ReactComponent as Arrow} from "../../../img/Argenco_pijl_eco_rgb.svg";

import {
  // Avatar,
  Box,
  Grid,
  List,
  ListItem,
  // CircularProgress,
  // Grid,
  // Stack,
} from '@mui/material';

import {
  // Benefit,
  Cta,
  Disclaimer,
  Footer,
  Hero,
  Section,
  WhiteSection,
} from '../../../components/v2/custom';
import {
  // DarkGreenButton,
  LightGreenButton,
  Page,
  Typography
} from '../../../components/v2/styled';

// import { Benefit as Ben } from '../../../models/Benefit';
// import { NewsItem as NI } from '../../models/NewsItem';
// import { User, loginFields } from '../../models/User';

// const { DateTime } = require("luxon");
// var he = require('he');

type Props = {}

export const NieuweLedenMaand2026: FunctionComponent<Props> = ({}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);


  // const {
  //   data: benefits,
  //   // isLoading: adviceUploadsLoading,
  //   // isError: adviceUploadsError,
  //   isSuccess: benefitsSuccess,
  //   // refetch: adviceUploadsRefetch,
  // } = useQuery({
  //   queryKey: ["nw", "benefits"],
  //   queryFn: () =>
  //     fetch_all<Ben>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
  //       {
  //         object: 'v2_benefit',
  //         fields: ['id', 'created_at', 'nw_timing', 'nw_discount_tag', 'discount_name', 'get_item'],
  //         per_page: 4,
  //         order: 'weight_homepage DESC',
  //         filter: {
  //           advanced: {
  //             enabled: 1
  //           }
  //         }
  //       },
  //       undefined
  //     ),
  //   // enabled: false,
  // });
  // const {
  //   data: userCount,
  //   isLoading: userCountLoading,
  //   // isError: adviceUploadsError,
  //   isSuccess: userCountSuccess,
  //   // refetch: adviceUploadsRefetch,
  // } = useQuery({
  //   queryKey: ["nw", "usercount"],
  //   queryFn: () =>
  //     fetch_one<{custom_result:{count: number, success: boolean}}>(
  //       `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
  //       {
  //         object: 'user',
  //         class_action: "custom_api_get_user_count"
  //       },
  //       undefined
  //     ),
  //   enabled: true,
  //   refetchInterval: 60 * 1000
  // });









  


  const greenBox = (num:number, title:string, text:string) => {
    return <Box
      sx={{
        backgroundColor: theme.palette.primary.light,
        borderRadius: '10px',
        padding: 4,
        width: '100%',
        height: '100%',
        position: 'relative'
      }}
    >
      <Typography variant="h3" sx={{
        fontSize: '78px',
        lineHeight: 'normal',
        marginBottom: 4
      }}>{num}</Typography>
      <Typography variant="h3" sx={{marginBottom: 4}}>{title}</Typography>
      <Typography variant="body1" sx={{color: theme.palette.primary.dark}}>{text}</Typography>
    </Box>;
  }
  const liArrow = () => {
    return <Box sx={{
      "& svg": {
        transform: "rotate(90deg)",
        width: '24px',
        marginBottom: -1
      },
      marginRight: 2.5
    }}><Arrow /></Box>
  }

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const lenis = new Lenis({
      // duration: 2,
    });
    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }, []);

  return <Page>
    <Hero
      picRight={HeroImg}
      children={<>
        <Typography variant="h5" html fuck_p_tags>{t("nw.reclame")}</Typography>
        <Typography variant="h1" sx={{
          marginBottom: 4, 
          marginTop: 2,
          lineHeight: {
            xs: "32px",
            md: "48px"
          }
        }}>{t("nw.landing.nieuweledenmaand2026.hero.title")}</Typography>
        <Typography variant="subtitle1" html fuck_p_tags altLinks sx={{color: theme.palette.primary.dark}}>{t("nw.landing.nieuweledenmaand2026.hero.subsection")}</Typography>
      </>}
    />

    <WhiteSection>
      <Typography variant="h2" sx={{marginBottom: 4}}>{t("nw.landing.nieuweledenmaand2026.faq.title")}</Typography>
      <List sx={{
        paddingLeft: 0,
        listStyle: 'none',
        "& li": {
          paddingLeft: 0
        }
      }} component="ul">
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.nieuweledenmaand2026.faq.li1")}</Typography></ListItem>
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.nieuweledenmaand2026.faq.li2")}</Typography></ListItem>
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.nieuweledenmaand2026.faq.li3")}</Typography></ListItem>
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.nieuweledenmaand2026.faq.li4")}</Typography></ListItem>
        <ListItem>{liArrow()} <Typography variant="subtitle1">{t("nw.landing.nieuweledenmaand2026.faq.li5")}</Typography></ListItem>
      </List>
    </WhiteSection>

    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      }
    }}>
      <Grid container spacing={2.5}>
        <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
          <Typography variant="h2" sx={{marginTop: 8}}>{t("nw.landing.nieuweledenmaand2026.boxes.title")}</Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          {greenBox(
            1,
            t("nw.landing.nieuweledenmaand2026.boxes_1.title"),
            t("nw.landing.nieuweledenmaand2026.boxes_1.text")
          )}
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          {greenBox(
            2,
            t("nw.landing.nieuweledenmaand2026.boxes_2.title"),
            t("nw.landing.nieuweledenmaand2026.boxes_2.text")
          )}
        </Grid>
        <Grid item xs={12} md={12} lg={4}>
          {greenBox(
            3,
            t("nw.landing.nieuweledenmaand2026.boxes_3.title"),
            t("nw.landing.nieuweledenmaand2026.boxes_3.text")
          )}
        </Grid>
      </Grid>
    </WhiteSection>

    <Section normalPage>
      <Cta>
        <Typography variant="h2" sx={{
          maxWidth: {
            xs: '100%',
            lg: '670px'
          },
          textAlign: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>{t("nw.landing.nieuweledenmaand2026.cta.title")}</Typography>
        <Typography variant="subtitle1" html fuck_p_tags altLinks sx={{
          color: theme.palette.primary.dark,
          marginTop: 4,
          maxWidth: {
            xs: '100%',
            lg: '670px'
          },
          textAlign: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>{t("nw.landing.nieuweledenmaand2026.cta.text")}</Typography>
        <Box sx={{
          marginTop: 4,
          width: '100%',
          textAlign: 'center'
        }}>
          <LightGreenButton
            id="goto_contact"
            label={t("nw.landing.nieuweledenmaand2026.cta.cta")}
            path="/buy"
          />
          <Disclaimer isSmall isAandelenKopen />
        </Box>
      </Cta>
    </Section>

    <Section normalPage>
      <Disclaimer />
    </Section>

    <Footer normalPage />
  </Page>;
}

